import { Station } from '@mi-front/core';
import { Route } from 'react-router-dom';
import { Page } from '../../../../components/page/Page';
import { Fragment } from '../../types';
import { FragmentAudiogramTab } from './components/audiogram/AudiogramTab';
import { FragmentContentAiView } from './components/content-ai/FragmentContentAiView';
import { FragmentFilesView } from './components/export/FragmentExportFilesView';
import { FragmentPublishView } from './components/export/FragmentExportPublishView';
import { FragmentsViewHeader } from './components/FragmentsViewHeader';
import { FragmentInfoView } from './components/info/FragmentInfoView';
import { FragmentVideoEditionsTab } from './components/video-editions/FragmentVideoEditionsTab';
import { useFragmentViewPreload } from './hooks/useFragmentViewPreload';

interface Props {
  readonly path: string;
  readonly data: {
    readonly station: Station;
    readonly fragment: Fragment;
  };
}

export function FragmentsViewScreenP(p: Props) {
  const { station, fragment } = p.data;

  useFragmentViewPreload(fragment);

  return (
    <Page htmlTitle={fragment.title}>
      <FragmentsViewHeader station={station} fragment={fragment} />
      <Page.Content>
        <Route path={`${p.path}/content-ai`} render={() => <FragmentContentAiView />} />
        <Route path={`${p.path}/files`} render={() => <FragmentFilesView fragment={fragment} />} />
        <Route
          path={`${p.path}/publish`}
          render={() => <FragmentPublishView station={station} fragment={fragment} />}
        />
        <Route
          path={`${p.path}/audiogram`}
          render={() => <FragmentAudiogramTab fragment={fragment} />}
        />
        <Route
          path={`${p.path}/video-editions`}
          render={() => <FragmentVideoEditionsTab fragment={fragment} station={station} />}
        />
        <Route
          exact
          path={p.path}
          render={() => <FragmentInfoView fragment={fragment} station={station} />}
        />
      </Page.Content>
    </Page>
  );
}
